import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      "welcome": "Bienvenue sur TravelIT",
      "dashboard": "Tableau de Bord",
      "clients": "Clients",
      "reservations": "Réservations",
      "packages": "Forfaits",
      "finances": "Finances",
      "suppliers": "Fournisseurs",
      "calendar": "Calendrier",
      "documents": "Documents",
      "reports": "Rapports",
      "settings": "Paramètres"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "fr",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 